import { useAccount } from "wagmi";
import { Button, ProfileAvatar } from "@looksrare/uikit";
import { formatCompactNumber } from "@looksrare/utils";
import { zeroAddress } from "viem";
import { Flex } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { ProfileNavPopover } from "@/components/ProfileNav";
import { useUserSeasonPoints } from "@/hooks";
import { useUser } from "@/queries/user";

interface ProfileNavButtonProps {
  isMobile?: boolean;
}

export const ProfileNavButton = ({ isMobile = false }: ProfileNavButtonProps) => {
  const { t } = useTranslation();

  const { address, isConnected } = useAccount();
  const { data: userPoints } = useUserSeasonPoints(address!, {
    enabled: !!address,
  });
  const { data: user } = useUser(address!, { enabled: !!address });

  if (!isConnected) {
    return null;
  }

  const ticketsNumberic = userPoints?.lotteryTickets?.remaining ? Number(userPoints?.lotteryTickets?.remaining) : 0;
  const tickets = formatCompactNumber(ticketsNumberic, "en", 1);

  return (
    <ProfileNavPopover address={address}>
      {isMobile ? (
        <Flex position="relative">
          <Button size="sm" padding={1} variant="outline" colorScheme="secondary">
            <ProfileAvatar
              src={user?.avatar?.image.src}
              size={24}
              address={address || zeroAddress}
              isPrivate={user?.isProfileImageVisible === false}
            />
          </Button>
        </Flex>
      ) : (
        <Flex position="relative">
          <Button
            size="sm"
            variant="outline"
            colorScheme="secondary"
            rightIcon={
              <ProfileAvatar
                src={user?.avatar?.image.src}
                address={address || zeroAddress}
                isPrivate={user?.isProfileImageVisible === false}
              />
            }
          >
            {tickets} {t("Tickets")}
          </Button>
        </Flex>
      )}
    </ProfileNavPopover>
  );
};
